<app-router-link [route]="Route.PL_ShoppingCartDetails">
  <div class="relative">
    @if (totalItems(); as totalItems) {
      <div
        class="bg-primary absolute inline-flex size-4 -translate-x-2 -translate-y-2 items-center justify-center rounded-full text-xs font-bold">
        {{ totalItems }}
      </div>
    }
    <app-header-icon [icon]="SvgIcon.Basket" />
  </div>
</app-router-link>
